import NERExtractorList from './NERExtractorList';
import NERTestReport from './NERTestReport';

export default {
  displayNameKey: 'ner',
  icon: 'menu_ner',
  pages: {
    NERExtractorList,
    NERTestReport,
  },
};



// WEBPACK FOOTER //
// ./src/modules/NER/index.js